<template>
  <div>
    <div class="bg">
      <v-container>
        <v-row>
          <v-col cols="12" class="text-center topheading">
            <h1 class="mb-0 white--text">
              <v-icon size="40" color="white" class="mr-2">mdi-facebook</v-icon
              >Facebook Competitive Analysis
            </h1>
          </v-col>
          <v-col cols="12">
            <v-card flat class="px-3 py-3">
              <v-row align="center">
                <v-col cols="2">
                  <v-tooltip v-if="superAdminUser" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="backToAgenciesDemoReports()"
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        dense
                        icon
                      >
                        <v-icon>mdi-arrow-left-bold-circle</v-icon>
                      </v-btn>
                    </template>
                    <span>Back</span>
                  </v-tooltip>
                  <v-tooltip v-if="standardAdmins" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="backToAgencyDemoReports()"
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        dense
                        icon
                      >
                        <v-icon>mdi-arrow-left-bold-circle</v-icon>
                      </v-btn>
                    </template>
                    <span>Back</span>
                  </v-tooltip>
                  <v-tooltip v-if="subscriberAdmins" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="backToSubscriptions()"
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        dense
                        icon
                      >
                        <v-icon>mdi-arrow-left-bold-circle</v-icon>
                      </v-btn>
                    </template>
                    <span>Back</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="8" class="text-center pb-0">
                  <h2>Analyzing posts from</h2>
                  <p class="my-2">
                    {{ this.dateTo }} - {{ this.dateFrom }}, {{ this.dateYear }}
                  </p>
                  <v-chip color="primary" dark
                    >Previous 30 days comparison</v-chip
                  >
                </v-col>
                <v-col cols="12">
                  <v-divider class="my-3"></v-divider>
                </v-col>
              </v-row>
              <v-row justify="center" align="center">
                <v-col cols="6">
                  <v-text-field
                    rounded
                    outlined
                    dense
                    v-model="search"
                    label="Search Page Name"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="text-right">
                  <v-dialog
                    v-if="standardAdmins || superAdminUser"
                    transition="dialog-top-transition"
                    max-width="600"
                    v-model="dialog"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        rounded
                        class="primary mr-4"
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        Send Link
                      </v-btn>
                    </template>
                    <template v-slot:default="dialog">
                      <v-card>
                        <v-card-text class="pt-4">
                          <v-row class="my-4">
                            <v-col cols="12" class="text-center">
                              <h2 class="steptext">Please Select Package</h2>
                            </v-col>
                            <v-col cols="12" class="py-0">
                              <v-select
                                v-model="selectedPackage"
                                :items="selectPackage"
                                label="Please Select Package"
                                item-text="text"
                                item-value="value"
                                class="selectpackage"
                              ></v-select>
                            </v-col>
                            <v-col
                              cols="12"
                              v-if="
                                agencyProfile.agencyName == 'Compeat.social'
                              "
                            >
                              Send Coupon
                              <v-radio-group v-model="coupon">
                                <v-radio label="Yes" :value="true"></v-radio>
                                <v-radio label="No" :value="false"></v-radio>
                              </v-radio-group>
                            </v-col>
                            <v-col cols="12" class="text-center">
                              <v-btn
                                class="compeatsecondary mr-2 white--text"
                                rounded
                                small
                                @click="closeDialog()"
                              >
                                Close
                              </v-btn>
                              <v-btn
                                :loading="sendingLink"
                                class="primary ml-2"
                                rounded
                                small
                                @click="sendLink()"
                                >Send</v-btn
                              >
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </template>
                  </v-dialog>
                  <v-btn
                    v-if="this.sorting != ''"
                    @click="resetFilter()"
                    fab
                    small
                    rounded
                    color="secondary"
                    class="mr-2"
                  >
                    <v-icon>mdi-history</v-icon>
                  </v-btn>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        rounded
                        fab
                        small
                      >
                        <v-icon>mdi-filter-variant</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(item, index) in items"
                        :key="index"
                        @click="sortData(item.action)"
                      >
                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>
              <v-divider class="mb-3"></v-divider>
              <v-row>
                <v-col class="postsbox" cols="12">
                  <v-card
                    min-width="300px"
                    max-width="300px"
                    v-for="item in filteredData"
                    :key="item.id"
                    class="py-4 px-4 mx-2"
                  >
                    <v-row justify="center" align="center">
                      <v-col cols="3" class="text-center">
                        <v-avatar>
                          <img
                            :src="item.facebookPageData.picture.data.url"
                            alt="John"
                          />
                        </v-avatar>
                      </v-col>
                      <v-col cols="9">
                        <h2 class="posttitle">
                          {{ item.facebookPageData.name }}
                        </h2>
                        <!-- <p class="mb-0"> {{ item.facebookPageData.fan_count }}</p> -->
                      </v-col>
                      <v-col cols="12" class="text-center py-0">
                        <h1>
                          {{
                            item.analysisOfPosts.engagement_per_post
                              | formattedTwoDecimals
                          }}
                        </h1>
                        <p class="mb-1">Engagement Per Post</p>
                        <v-divider></v-divider>
                      </v-col>
                      <v-col cols="6" class="text-center">
                        <h3 class="mb-0 font-weight-black">
                          {{
                            item.facebookPageData.fan_count | formattedToMilOrK
                          }}
                        </h3>
                        <p class="mb-0">Audience</p>
                      </v-col>
                      <v-col cols="6" class="text-center mb-0">
                        <h3 class="mb-0 font-weight-black">
                          {{
                            item.analysisOfPosts.posts_per_week
                              | formattedTwoDecimals
                          }}
                        </h3>
                        <p class="mb-0">Post Per Week</p>
                      </v-col>
                      <v-col cols="12">
                        <v-card
                          height="660px"
                          v-for="item in item.topTwoPosts"
                          :key="item.id"
                          class="py-3 px-3 my-2 cardsradius"
                        >
                          <v-img
                            class="white--text align-end"
                            height="200px"
                            :src="item.media_url"
                            :lazy-src="item.media_url"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                          <v-row>
                            <v-col cols="12 pb-0 mt-2 postcontent">
                              {{ item.content }}
                              <v-divider class="mt-2"></v-divider>
                            </v-col>
                            <v-col cols="2" class="text-center px-1">
                              <p class="mb-0 reactiontext">{{ item.likes }}</p>
                              <v-img
                                src="../assets/like.png"
                                width="25px"
                                class="mx-auto"
                              />
                            </v-col>
                            <v-col cols="2" class="text-center px-1">
                              <p class="mb-0 reactiontext">{{ item.love }}</p>
                              <v-img
                                src="../assets/love.png"
                                width="25px"
                                class="mx-auto"
                              />
                            </v-col>
                            <v-col cols="2" class="text-center px-1">
                              <p class="mb-0 reactiontext">{{ item.wow }}</p>
                              <v-img
                                src="../assets/wow.png"
                                width="25px"
                                class="mx-auto"
                              />
                            </v-col>
                            <v-col cols="2" class="text-center px-1">
                              <p class="mb-0 reactiontext">{{ item.sad }}</p>
                              <v-img
                                src="../assets/sad.png"
                                width="25px"
                                class="mx-auto"
                              />
                            </v-col>
                            <v-col cols="2" class="text-center px-1">
                              <p class="mb-0 reactiontext">{{ item.haha }}</p>
                              <v-img
                                src="../assets/haha.png"
                                width="25px"
                                class="mx-auto"
                              />
                            </v-col>
                            <v-col cols="2" class="text-center px-1">
                              <p class="mb-0 reactiontext">{{ item.angry }}</p>
                              <v-img
                                src="../assets/angry.png"
                                width="25px"
                                class="mx-auto"
                              />
                            </v-col>
                            <v-col cols="12" class="py-0">
                              <v-divider></v-divider>
                            </v-col>
                            <v-col cols="12" class="text-center my-2">
                              <v-icon color="primary">mdi-share-variant</v-icon>
                              Shares {{ item.shares }}
                            </v-col>
                            <v-col cols="12" class="py-0">
                              <v-divider></v-divider>
                            </v-col>
                            <v-col cols="12" class="text-center my-2">
                              <v-icon color="primary">mdi-sticker-emoji</v-icon>
                              Total Reactions {{ item.reactions }}
                            </v-col>
                            <v-col cols="12" class="py-0">
                              <v-divider></v-divider>
                            </v-col>
                            <v-col cols="12" class="text-center">
                              <v-btn
                                rounded
                                color="primary"
                                :href="item.permalink_url"
                                target="_blank"
                              >
                                View Post
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="lightgrey">
      <v-container>
        <v-row>
          <v-col cols="12" class="my-6 text-center">
            <h1>ACTIVITY</h1>
            <p>
              Measure the activity and effectiveness of your social media
              campaigns to gauge how well your audience is engaging with your
              posts.
            </p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div>
      <v-container>
        <v-row>
          <v-col cols="12" class="my-6">
            <h1>Daily Posts</h1>
            <p>
              By posting multiple times a day you get more opportunities to get
              your brand in front of your audience. Find the balance between
              being heard and less-being more with statistics about your daily
              posts.
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="7" lg="7">
            <v-list>
              <v-list-item-group color="primary">
                <v-list-item v-for="item in selectedReport.data" :key="item.id">
                  <v-list-item-icon>
                    <v-avatar>
                      <img
                        sizes="50"
                        :src="item.facebookPageData.picture.data.url"
                        alt="John"
                      />
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      item.facebookPageData.name
                    }}</v-list-item-title>
                  </v-list-item-content>
                  <v-spacer></v-spacer>
                  <v-list-item-content class="text-right">
                    <v-list-item-title>{{
                      item.analysisOfPosts.average_daily_posts
                        | formattedTwoDecimals
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
          <v-col cols="12" sm="12" md="5" lg="5">
            <barChartVertical
              :seriesInfo="averageDailyPosts"
              :facebookPageNameArray="facebookPageNameArray"
            />
          </v-col>

          <v-col cols="12" class="my-6">
            <h1>Days Per Week With Posts</h1>
            <p>
              Stay relevant, consistent, authoritative and at the forefront of
              your audience’s attention by posting regularly!
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="7" lg="7">
            <v-list>
              <v-list-item-group color="primary">
                <v-list-item v-for="item in selectedReport.data" :key="item.id">
                  <v-list-item-icon>
                    <v-avatar>
                      <img
                        sizes="50"
                        :src="item.facebookPageData.picture.data.url"
                        alt="John"
                      />
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      item.facebookPageData.name
                    }}</v-list-item-title>
                  </v-list-item-content>
                  <v-spacer></v-spacer>
                  <v-list-item-content class="text-right">
                    <v-list-item-title>{{
                      item.analysisOfPosts.days_per_week_with_post
                        | formattedTwoDecimals
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
          <v-col cols="12" sm="12" md="5" lg="5">
            <barChartVertical
              :seriesInfo="daysPerWeekWithPosts"
              :facebookPageNameArray="facebookPageNameArray"
            />
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>

          <v-col cols="12" class="my-6">
            <h1>Percentage of Posts with Links</h1>
            <p>
              Give your viewers a reason to stop scrolling for a moment by
              getting them to engage more meaningfully with your posts. You can
              do this by creating content that is interesting and helpful to the
              viewer.
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="7" lg="7">
            <v-list>
              <v-list-item-group color="primary">
                <v-list-item v-for="item in selectedReport.data" :key="item.id">
                  <v-list-item-icon>
                    <v-avatar>
                      <img
                        sizes="50"
                        :src="item.facebookPageData.picture.data.url"
                        alt="John"
                      />
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      item.facebookPageData.name
                    }}</v-list-item-title>
                  </v-list-item-content>
                  <v-spacer></v-spacer>
                  <v-list-item-content class="text-right">
                    <v-list-item-title>{{
                      item.analysisOfPosts.percent_post_with_links
                        | formattedTwoDecimals
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
          <v-col cols="12" sm="12" md="5" lg="5">
            <barChartVertical
              :seriesInfo="percentagePostLinks"
              :facebookPageNameArray="facebookPageNameArray"
            />
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="lightgrey">
      <v-container>
        <v-row>
          <v-col cols="12" class="my-6 text-center">
            <h1>Engagement</h1>
            <p>
              Spot the elements in your posts that encourage your viewers to act
              and interact meaningfully with your brand.
            </p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div>
      <v-container>
        <v-row>
          <v-col cols="12" class="my-6">
            <h1>Engagement Total per Post</h1>
            <p>
              You want as many reactions, comments, and shares as possible for
              each post. Remember, that more engagement means more people will
              be seeing your content and interacting with your brand.
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="7" lg="7">
            <v-list>
              <v-list-item-group color="primary">
                <v-list-item v-for="item in selectedReport.data" :key="item.id">
                  <v-list-item-icon>
                    <v-avatar>
                      <img
                        sizes="50"
                        :src="item.facebookPageData.picture.data.url"
                        alt="John"
                      />
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      item.facebookPageData.name
                    }}</v-list-item-title>
                  </v-list-item-content>
                  <v-spacer></v-spacer>
                  <v-list-item-content class="text-right">
                    <v-list-item-title>{{
                      item.analysisOfPosts.engagement_per_post
                        | formattedTwoDecimals
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
          <v-col cols="12" sm="12" md="5" lg="5">
            <barChartVertical
              :seriesInfo="engagmentTotalPerPost"
              :facebookPageNameArray="facebookPageNameArray"
            />
          </v-col>

          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>

          <v-col cols="12" class="my-6">
            <h1>Engagement Rate</h1>
            <p>
              Engagement Rates offer a measure of how excited your audience is
              about your content, by quantifying how meaningfully they interact
              with them according to the ratio of your followers.
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="7" lg="7">
            <v-list>
              <v-list-item-group color="primary">
                <v-list-item v-for="item in selectedReport.data" :key="item.id">
                  <v-list-item-icon>
                    <v-avatar>
                      <img
                        sizes="50"
                        :src="item.facebookPageData.picture.data.url"
                        alt="John"
                      />
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      item.facebookPageData.name
                    }}</v-list-item-title>
                  </v-list-item-content>
                  <v-spacer></v-spacer>
                  <v-list-item-content class="text-right">
                    <v-list-item-title>{{
                      item.analysisOfPosts.engagement_rate
                        | formattedTwoDecimals
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
          <v-col cols="12" sm="12" md="5" lg="5">
            <barChartVertical
              :seriesInfo="engagmentRate"
              :facebookPageNameArray="facebookPageNameArray"
            />
          </v-col>

          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>

          <v-col cols="12" class="my-6">
            <h1>Shares Per Post</h1>
            <p>
              Shared posts get you more coverage and gets your message out
              further. The more shares you get, the more your brand will
              resonate through the market.
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="7" lg="7">
            <v-list>
              <v-list-item-group color="primary">
                <v-list-item v-for="item in selectedReport.data" :key="item.id">
                  <v-list-item-icon>
                    <v-avatar>
                      <img
                        sizes="50"
                        :src="item.facebookPageData.picture.data.url"
                        alt="John"
                      />
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      item.facebookPageData.name
                    }}</v-list-item-title>
                  </v-list-item-content>
                  <v-spacer></v-spacer>
                  <v-list-item-content class="text-right">
                    <v-list-item-title>{{
                      item.analysisOfPosts.shares_per_post
                        | formattedTwoDecimals
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
          <v-col cols="12" sm="12" md="5" lg="5">
            <barChartVertical
              :seriesInfo="sharesPerPost"
              :facebookPageNameArray="facebookPageNameArray"
            />
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="lightgrey">
      <v-container>
        <v-row>
          <v-col cols="12" class="my-6 text-center">
            <h1>Audience</h1>
            <p>
              Find out who is behind the likes and comments that get your brand
              known. Find out who they are, how they behave, and which posts
              they are interacting most with
            </p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div>
      <v-container>
        <v-row>
          <v-col cols="12" class="my-6">
            <h1>Audience</h1>
            <p>
              Find out who is behind the likes and comments that get your brand
              known. Find out who they are, how they behave, and which posts
              they are interacting most with.
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="7" lg="7">
            <v-list>
              <v-list-item-group color="primary">
                <v-list-item v-for="item in selectedReport.data" :key="item.id">
                  <v-list-item-icon>
                    <v-avatar>
                      <img
                        sizes="50"
                        :src="item.facebookPageData.picture.data.url"
                        alt="John"
                      />
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      item.facebookPageData.name
                    }}</v-list-item-title>
                  </v-list-item-content>
                  <v-spacer></v-spacer>
                  <v-list-item-content class="text-right">
                    <v-list-item-title>{{
                      item.facebookPageData.fan_count | formattedToMilOrK
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
          <v-col cols="12" sm="12" md="5" lg="5">
            <barChartVertical
              :seriesInfo="audience"
              :facebookPageNameArray="facebookPageNameArray"
            />
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="120"
        >Please Wait...</v-progress-circular
      >
    </v-overlay>
  </div>
</template>

<script>
const db = getFirestore(firebaseApp);
import barChartVertical from "../components/charts/barChartVertical.vue";
import { firebaseApp } from "../firebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import moment from "moment-timezone";

import { getFunctions, httpsCallable } from "firebase/functions";

export default {
  props: ["reportId"],
  components: {
    barChartVertical,
  },
  data: () => ({
    sorting: "",
    search: "",
    items: [
      { text: "Engagement Per Post", action: "engagement_per_post" },
      { text: "Audience", action: "fan_count" },
      { text: "Posts Per Week", action: "posts_per_week" },
    ],
    selectPackage: [
      { text: "Package 1", value: "package-1" },
      { text: "Package 2", value: "package-2" },
      { text: "Package 3", value: "package-3" },
    ],
    selectedPackage: "",
    filterBy: "",
    selectedSubscription: [],
    selectedReport: [],
    dateFrom: "",
    dateTo: "",
    dateYear: "",
    daysPerWeekWithPosts: [],
    facebookPageNameArray: [],
    percentagePostLinks: [],
    engagmentTotalPerPost: [],
    engagmentRate: [],
    sharesPerPost: [],
    audience: [],
    averageDailyPosts: [],
    originalData: [],
    colsss: 4,
    overlay: false,
    superAdminUser: false,
    standardAdmins: false,
    subscriberAdmins: false,
    noUser: false,

    dialog: false,
    sendingLink: false,

    //agency varibles
    agencyProfile: [],
    coupon: false,
  }),
  created() {
    this.getCurrentUser();
  },
  computed: {
    filteredData() {
      if (!this.selectedReport || !this.selectedReport.data) {
        return [];
      }
      // filter the data based on the search field
      return this.selectedReport.data.filter((item) =>
        item.facebookPageData.name
          .toLowerCase()
          .includes(this.search.toLowerCase())
      );
    },
  },
  filters: {
    formattedTwoDecimals(value) {
      return value.toFixed(2);
    },
    formattedToMilOrK(value) {
      const isMillion = Math.abs(value) >= 1e6;
      const isThousand = Math.abs(value) >= 1e3 && Math.abs(value) < 1e6;
      value = isMillion
        ? (value / 1e6).toFixed(2) + "M"
        : isThousand
        ? (value / 1e3).toFixed(2) + "K"
        : value.toFixed(2);
      return value.toLocaleString("en-US");
    },
  },
  methods: {
    getCurrentUser() {
      const auth = getAuth();
      onAuthStateChanged(auth, (user) => {
        if (user) {
          const getdata = async () => {
            const docRef = doc(db, "users", user.uid);
            const docSnap = await getDoc(docRef);
            let userRole = docSnap.data().userType;
            if (userRole == "SMM" || userRole == "AA") {
              this.standardAdmins = true;
            } else if (userRole == "SA") {
              this.superAdminUser = true;
            } else if (userRole == "SB" || userRole == "AS") {
              this.subscriberAdmins = true;
            }
          };
          getdata();
          this.getReport();
        } else {
          this.noUser = true;
          this.getReport();
        }
      });
    },
    async getReport() {
      this.overlay = true;
      try {
        const docRef = doc(db, "demoreports", this.reportId); // Use doc() to create a reference to the document
        const docSnapshot = await getDoc(docRef); // Use getDoc() to retrieve the document snapshot

        if (!docSnapshot.exists()) {
          throw new Error("Document not found");
        }
        this.selectedReport = docSnapshot.data();
        this.originalData = [...this.selectedReport.data];
        this.dateFrom = moment(this.selectedReport.createdAt).format("DD MMMM");
        this.dateTo = moment(this.selectedReport.createdAt)
          .subtract(30, "days")
          .format("DD MMMM");
        this.dateYear = moment(this.selectedReport.createdAt).format("YYYY");

        let postsPerWeekSeries = [];
        let percentagePostLinksSeries = [];
        let engagmentTotalPerPostSeries = [];
        let engagementRatesSeries = [];
        let sharesPerPostSeries = [];
        let audienceSeries = [];
        let averageDaliyPostSeries = [];

        this.selectedReport.data.forEach((obj) => {
          const postsPerWeek = obj.analysisOfPosts.posts_per_week;
          const percentagePostWithLinks =
            obj.analysisOfPosts.percent_post_with_links;
          const engagmentPerPost = obj.analysisOfPosts.engagement_per_post;
          const engagmentRateAverage = obj.analysisOfPosts.engagement_rate;
          const sharesPerTopPosts = obj.analysisOfPosts.shares_per_post;
          const audienceTotal = obj.facebookPageData.fan_count;
          const facebookPageName = obj.facebookPageData.name;
          const averDailyPost = obj.analysisOfPosts.average_daily_posts;

          postsPerWeekSeries.push(postsPerWeek);
          percentagePostLinksSeries.push(percentagePostWithLinks);
          engagmentTotalPerPostSeries.push(engagmentPerPost);
          engagementRatesSeries.push(engagmentRateAverage);
          sharesPerPostSeries.push(sharesPerTopPosts);
          audienceSeries.push(audienceTotal);
          averageDaliyPostSeries.push(averDailyPost);
          this.facebookPageNameArray.push(facebookPageName);
        });

        this.daysPerWeekWithPosts = {
          series: [
            {
              name: "Days per week with posts",
              data: postsPerWeekSeries,
            },
          ],
        };

        this.percentagePostLinks = {
          series: [
            {
              name: "Percentage of posts with links",
              data: percentagePostLinksSeries,
            },
          ],
        };

        this.engagmentTotalPerPost = {
          series: [
            {
              name: "Engagement total per post",
              data: engagmentTotalPerPostSeries,
            },
          ],
        };

        this.engagmentRate = {
          series: [
            {
              name: "Engagement Rate",
              data: engagementRatesSeries,
            },
          ],
        };

        this.sharesPerPost = {
          series: [
            {
              name: "Shares Per Post",
              data: sharesPerPostSeries,
            },
          ],
        };

        this.audience = {
          series: [
            {
              name: "Audience",
              data: audienceSeries,
            },
          ],
        };

        this.averageDailyPosts = {
          series: [
            {
              name: "Average daily posts",
              data: averageDaliyPostSeries,
            },
          ],
        };
        this.getAgencyInfo();
      } catch (err) {
        console.log("err", err);
      }
    },
    resetFilter() {
      this.selectedReport.data = [...this.originalData];
      this.sorting = "";
    },
    sortData(type) {
      // set the sorting type
      this.sorting = type;

      if (type === "fan_count") {
        // sort the facebookPageData array
        this.selectedReport.data.sort((a, b) => {
          if (a.facebookPageData[type] < b.facebookPageData[type]) {
            return 1;
          }
          if (a.facebookPageData[type] > b.facebookPageData[type]) {
            return -1;
          }
          return 0;
        });
      } else {
        // sort the selectedReport.data array
        this.selectedReport.data.sort((a, b) => {
          if (a.analysisOfPosts[type] < b.analysisOfPosts[type]) {
            return 1;
          }
          if (a.analysisOfPosts[type] > b.analysisOfPosts[type]) {
            return -1;
          }
          return 0;
        });
      }
    },
    //Gets agency info if client has been cleared with facebook verification
    async getAgencyInfo() {
      try {
        const docRef = doc(db, "agencies", this.selectedReport.agencyId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          this.agencyProfile = docSnap.data();
          this.overlay = false;
        } else {
          console.log("No such document!");
          this.overlay = false;
        }
      } catch (err) {
        console.log("getAgencyInfo err", err);
        this.overlay = false;
      }
    },
    //For Super admins back button
    backToAgenciesDemoReports() {
      this.$router.push({
        name: "singleAgency",
        params: {
          id: this.selectedReport.agencyId,
        },
      });
    },
    //For Agency admins back button
    backToAgencyDemoReports() {
      this.$router.push({
        name: "demoSubscriptions",
      });
    },
    //For Subscribers back button
    backToSubscriptions() {
      this.$router.push({
        name: "dashboard",
      });
    },
    //send link to client to purchase
    sendLink() {
      this.sendingLink = true;
      const prospectingClientName = this.selectedReport.prospectingClientName;

      // Remove extra spaces and split the full name into first name and last name
      const cleanedName = prospectingClientName.replace(/\s+/g, " ").trim();
      const names = cleanedName.split(" ");

      if (names.length >= 2) {
        const firstName = names[0];
        let lastName = names[1];
        if (names.length > 2) {
          lastName += " " + names.slice(2).join(" ");
        }

        const functions = getFunctions(firebaseApp, "europe-west2");
        const createPackageUrl = httpsCallable(functions, "createPackageUrl");

        createPackageUrl({
          firstName: firstName,
          lastName: lastName,
          email: this.selectedReport.prospectingClientEmail,
          reportId: this.reportId,
          agency: this.agencyProfile,
          selectedPackage: this.selectedPackage,
          coupon: this.coupon,
        })
          .then((result) => {
            console.log("result", result);
            this.sendingLink = false;
            this.closeDialog();
          })
          .catch((error) => {
            console.log(error);
            this.searchPageError = true;
            this.searchErrorMessage = "Something went wrong please try again";
          });
      } else {
        console.log(
          "Invalid name format. Please provide at least a first name and last name."
        );
      }
    },
    //open and close dialog
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>

<style>
.bg {
  background-color: #3d6eb1;
  height: 100%;
}

.lightgrey {
  background-color: #e3e3e3;
}

.reactiontext {
  font-size: 12px;
}

.postcontent {
  height: 180px;
  overflow: hidden;
}

.postsbox {
  display: flex;
  overflow-x: scroll;
}

.posttitle {
  height: 72px;
  overflow-y: hidden;
}
</style>
